export class Value {
    public static IsNotNullOrUndefined(value: any): boolean {
        return (value !== null && value !== undefined);
    }
    public static IsNullOrUndefined(value: any): boolean {
        if (value === null || value === undefined) {
            return true;
        }
        if (value === '') {
            return true;
        }
        if (typeof value === 'string' && (value as string).trim() === '') {
            return true;
        }
        return !(value !== null && value !== undefined);
    }    
}